import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import invariant from 'invariant';
import Loader from 'components/Loader';
// import Modal from 'react-bootstrap/lib/Modal';
import api, {
  updateDefaultsESPN,
  getStartHeaderInfo,
  getApaAssets,
  getApaMetadata,
  postLoginEspn,
} from './services';
import getConfigEnv from '../../react/utils/getConfigEnv';
import { EmailForm, PasswordForm } from './components/Login';

import { getTranslations } from './selectors';

import * as c from './constants';

import './style.scss';

const apiParamsDefault = {
  "device_id": "web",
  "device_category": "web",
  "device_manufacturer": "generic",
  "device_model": "web",
  "device_type": "web",
  "api_version": "v5.93",
  "authpn": "webclient",
  "authpt": "tfg1h3j4k6fd7",
  "format": "json",
  "HKS": "",
}

const startHIParams = {
  ...apiParamsDefault,
  HKS: "",
};

const Login = () => {
  const [activeStep, setActiveStep] = useState(c.STEPS.EMAIL_FORM);
  const [data, setData] = useState({});
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    msg: '',
    show: false,
  });

  useEffect(() => {
    const apa = async () => {
      const { response: headerInfo } = await getStartHeaderInfo(startHIParams);
      await updateConfig(headerInfo);
      const config = getConfigEnv(headerInfo.region);
      const metadata = await getApaMetadata({
        sessionKey: `${config.app_key}-${headerInfo.region}`,
      });

      const assets = await getApaAssets({
        sessionKey: `${config.app_key}-${headerInfo.region}`,
      });
      setData({ headerInfo, metadata, assets, config });
    };
    apa();
  }, []);

  const updateConfig = async respShi => {
    const { region, session_stringvalue: hks } = respShi;
    const config = getConfigEnv(region);
    setData({ ...data, config });
    const defaults = _.pick(config, [
      'authpn',
      'authpt',
      'api_version',
      'user_hash',
    ]);
    const params = _.merge({}, c.rest, { region, HKS: hks }, defaults);
    await updateDefaultsESPN(api, {
      params,
    });
  };

  const handleClearErrors = () => {
    setError({
      msg: '',
      show: false,
    });
  };

  const handleSubmit = async body => {
    let resUserLogin;
    setLoading(true);
    try {
      resUserLogin = await postLoginEspn(body);
      const { status, response } = resUserLogin;
      invariant(_.parseInt(status, 10) === 0, 'Error');
      window.location = response.url;
    } catch (err) {
      const translations = getTranslations(data, data.headerInfo.region);
      const defaultErrorCode = _.get(
        resUserLogin,
        ['errors', '0', 'code'],
        c.DEFAULT_ERROR_CODE,
      );
      const CODE_ERROR = _.get(
        resUserLogin,
        ['errors', 'code'],
        defaultErrorCode,
      );
      const msg = _.get(translations, CODE_ERROR, '');
      setError({ show: true, msg });
      setLoading(false);
    }
  };

  const processSubmitAction = async (submitAction, values) => {
    switch (submitAction) {
      case c.SUBMIT_TYPES.previous:
        setActiveStep(activeStep - 1);
        break;
      case c.SUBMIT_TYPES.next:
        setActiveStep(activeStep + 1);
        break;
      case c.SUBMIT_TYPES.email:
        setActiveStep(c.STEPS.EMAIL_FORM);
        break;
      case c.SUBMIT_TYPES.validateEmail: {
        setActiveStep(c.STEPS.PASSWORD_FORM);

        break;
      }
      case c.SUBMIT_TYPES.submit: {
        const body = { ...form, password: values.password };
        setForm({ ...body });
        await handleSubmit(body);
        break;
      }
      case c.SUBMIT_TYPES.done:
        break;
      default:
        throw new Error(`Submit action ${submitAction} not supported`);
    }
  };
  const getActiveComponent = () => {
    const translations = getTranslations(data, data.headerInfo.region);
    switch (activeStep) {
      case c.STEPS.EMAIL_FORM:
        return (
          <EmailForm
            translations={translations}
            assets={data.assets}
            onNextClicked={values => {
              setForm({ ...form, username: values.emailRegister });
              processSubmitAction(c.SUBMIT_TYPES.validateEmail);
            }}
          />
        );
      case c.STEPS.PASSWORD_FORM:
        return (
          <PasswordForm
            translations={translations}
            assets={data.assets}
            error={error}
            isLoading={loading}
            onClearError={() => handleClearErrors()}
            onCancelClicked={() => {
              handleClearErrors();
              processSubmitAction(c.SUBMIT_TYPES.previous);
            }}
            onNextClicked={values => {
              processSubmitAction(c.SUBMIT_TYPES.submit, values);
              handleClearErrors();
            }}
          />
        );
      default:
        throw new Error(`Step ${activeStep} not supported`);
    }
  };
  const translations =
    data.headerInfo && getTranslations(data, data.headerInfo.region);
  return (
    <>
      {translations ? (
        <div className="landingPage">
          <div>{getActiveComponent()}</div>
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default Login;
